/** Logical FlowV2 URL: tenant prefix + folder path + class + method. */

/** Safe path-segment charset for a release pin / version label (semver-friendly). */
const RELEASE_PIN_SAFE = /[^A-Za-z0-9._-]/g;
const RESERVED_RELEASE_PINS = new Set(['latest', 'sandbox']);

export function filterReleasePinInput(value) {
    return String(value || '').replace(RELEASE_PIN_SAFE, '');
}

export function isReservedReleasePin(value) {
    const v = String(value || '').trim().toLowerCase();
    return RESERVED_RELEASE_PINS.has(v);
}

export function sanitizeSegment(segment) {
    if (segment == null || segment === '')
        return '';
    return String(segment)
        .replace(/\\/g, '/')
        .replace(/^\/+|\/+$/g, '')
        .replace(/\s+/g, '-')
        .replace(/\//g, '-');
}

export function sanitizeLogicalUri(url) {
    if (url == null || url === '')
        return '';
    return String(url)
        .replace(/\\/g, '/')
        .split('/')
        .map((part) => (part === '' ? '' : sanitizeSegment(part)))
        .join('/');
}

export function projectFullName(path, name) {
    const n = sanitizeSegment(name);
    const p = String(path || '')
        .replace(/\\/g, '/')
        .replace(/^\/+|\/+$/g, '')
        .split('/')
        .map(sanitizeSegment)
        .filter(Boolean)
        .join('/');
    if (!p)
        return n;
    return `${p}/${n}`;
}

export function buildLogicalUri(tenantPrefix, path, parentFolder, name) {
    const prefix = String(tenantPrefix || 'Apps/User').replace(/\\/g, '/').replace(/\/+$/g, '');
    const rest = [path, parentFolder, name]
        .filter((s) => s != null && String(s).length > 0)
        .join('/');
    const sanitizedRest = String(rest)
        .replace(/\\/g, '/')
        .replace(/^\/+/g, '')
        .split('/')
        .map(sanitizeSegment)
        .filter(Boolean)
        .join('/');
    return `${prefix}/${sanitizedRest}`;
}

export async function resolveLogicalUri(api, { projectPath, projectName, className, methodName }) {
    try {
        const res = await api.get(
            `Apps/FlowV2/GetLogicalWebUrl?projectPath=${encodeURIComponent(projectPath || '')}`
            + `&projectName=${encodeURIComponent(projectName || '')}`
            + `&className=${encodeURIComponent(className || '')}`
            + `&methodName=${encodeURIComponent(methodName || '')}`,
        );
        if (res?.Template)
            return sanitizeLogicalUri(res.Template);
    }
    catch {
        // fall through
    }
    return buildLogicalUri('Apps/User', projectPath, projectName ? `${projectName}/${className}` : className, methodName);
}
